import { IonCard, IonCardContent, IonItem } from '@ionic/react';
import React from 'react';

interface LoadingCardProps {
  message: string;
}

const LoadingCard: React.FC<LoadingCardProps> = ({ message }) => (
  <IonCard>
    <IonCardContent>
      <IonItem>
        {message}
      </IonItem>
    </IonCardContent>
  </IonCard>
);

export default LoadingCard;
